export default {
    title: 'New Authorization',
    type: 'Authorization type',
    typeSubtitle: 'Select an authorization type to continue:',
    footerTitle: 'Select an authorization type to continue:',
    backBtn: 'Cancel',
    continueBtn: 'Continue',
    medicalTypes : {
        subHeader: 'MEDICAL',
        medicines: 'Medicines',
        diagnostic: 'Diagnoses',
        diagnostic_study: 'Diagnostic study',
        laboratories: 'Laboratories',
        outpatientCare: 'Outpatient care',
        procedure: 'Medical Procedure',
        generic: 'Generic'
    },
    navBar: {
        medicines: '(Medicines)',
        diagnostic: '(Diagnoses)',
        diagnostic_study: '(Diagnostic study)',
        laboratories: '(Laboratories)',
        outpatientCare: '(Outpatient care)',
        process: '(Medical Process)'
    }
}